import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singleEvidenceSelectors } from "store/admin-slices/single-evidence-slice/selectors";
import { singleEvidenceActions } from "store/admin-slices/single-evidence-slice/slice";

import { EvidenceSideBar } from "./EvidenceSideBar";
import { EvidenceTable } from "./EvidenceTable";
import { SettingsModal } from "./SettingsModal";
import * as S from "./styled";

export const EvidenceSinglePage = () => {
  const { isOpenSettingsModal } = useSelector(singleEvidenceSelectors);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(singleEvidenceActions.resetAllData());
  }, []);

  return (
    <S.EvidenceContainer>
        <>
          <EvidenceSideBar />
          <EvidenceTable />
          {isOpenSettingsModal && <SettingsModal />}
        </>
    </S.EvidenceContainer>
  );
};
